import React from "react";


import parseHTML from "html-react-parser";


import { Col, Row } from "react-bootstrap";


import SectionContainerComponent from "@Components/Sections/SectionContainer";


import "./index.scss";


type HeadSectionComponentProps = {
    pageName: string;
    sectionHeaderText?: string;
    sectionSubText?: string;
    sectionImage?: string;
    children?: React.ReactNode | React.ReactNode[];
};


export const HeadSectionComponent:React.FC<HeadSectionComponentProps> = ({
    pageName,
    sectionHeaderText, sectionSubText,
    sectionImage,
    children
}) => {


    return (
        <SectionContainerComponent id={`${pageName}__page-head-section page-head-section`}>

            <Col xs={12} xl={6} className={`${pageName}__page-head-section__section-content page-head-section__section-content`}>
                <Row className={`${pageName}__page-head-section__section-content__content page-head-section__section-content__content`}>

                    {sectionHeaderText &&
                    <Col xs={12} className={`${pageName}__page-head-section__section-content__header page-head-section__section-content__header`}>
                        {parseHTML(sectionHeaderText)}
                    </Col>
                    }

                    {sectionSubText &&
                    <Col xs={12} className={`${pageName}__page-head-section__section-content__text page-head-section__section-content__text`}>
                        {parseHTML(sectionSubText)}
                    </Col>
                    }

                    {children &&
                    <Col xs={12} className={`${pageName}__page-head-section__section-content__extra-content page-head-section__section-content__extra-content`}>
                        {children}
                    </Col>
                    }

                </Row>
            </Col>

            <Col xs={12} xl={6} className={`${pageName}__page-head-section__section-image page-head-section__section-image`}>
                <Row className={`${pageName}__page-head-section__section-image page-head-section__section-image__content`}>
                    {sectionImage && <img src={sectionImage} alt={''} />}
                </Row>
            </Col>

        </SectionContainerComponent>
    );

};


export default HeadSectionComponent;
